import { render, staticRenderFns } from "./MpcExchange.vue?vue&type=template&id=729944a8&scoped=true"
import script from "./MpcExchange.vue?vue&type=script&lang=js"
export * from "./MpcExchange.vue?vue&type=script&lang=js"
import style0 from "./MpcExchange.vue?vue&type=style&index=0&id=729944a8&prod&lang=less"
import style1 from "./MpcExchange.vue?vue&type=style&index=1&id=729944a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729944a8",
  null
  
)

export default component.exports